var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import AppBody from "../components/AppBody";
import { Button } from "@savvyinsure/react-ui";
import Container from "../components/connect-ui/Container";
import Header from "../components/Header";
import Image from "../components/Image";
import { PHASE } from "../routeConfig";
import RouteHeaderLogo from "../components/RouteHeaderLogo";
import RouteTitle from "../components/RouteTitle";
import { completedPage } from "../lib/Avo";
import useAppSelector from "../hooks/useAppSelector";
import useCurrentProductLine from "../hooks/useCurrentProductLine";
import useMemoryHistory from "../hooks/useMemoryHistory";
var items = [
    {
        image: "/assets/icons/stopwatch.svg",
        title: "Save time",
        content: "Import your existing insurance details  quickly using your online credentials",
    },
    {
        image: "/assets/icons/document-check.svg",
        title: "Get relevant offers",
        content: "View offers that can include your existing coverages and discounts",
    },
];
export default function SavvyIntroRoute() {
    var history = useMemoryHistory();
    var productLine = useCurrentProductLine();
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var nextRoute = productLine === "home" ? PHASE.HOME_HAVE_LOGIN : PHASE.HAVE_LOGIN;
    var selectedIssuer = useAppSelector(function (state) {
        return productLine === "home"
            ? state.applicant.currentIssuer.home
            : state.applicant.currentIssuer.auto;
    });
    function handleSubmit() {
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: "Next", optionSelected: "Next" }));
        history.push(nextRoute);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, { className: "grow overflow-y-scroll" },
            React.createElement("div", { className: "mb-4 w-full md:mb-6" },
                React.createElement(Image, { src: "/assets/images/savvy-intro-hero.svg", className: "w-full" })),
            React.createElement(Container, { className: "flex h-full flex-col" },
                React.createElement("div", { className: "grow" },
                    React.createElement(RouteTitle, { className: "mb-1 text-center font-bold" }, "Great news!"),
                    React.createElement("h2", { className: "mb-3 text-center text-black-100 sm:mb-4 md:mb-6 md:text-xl desktop:text-lg" },
                        "You can import your",
                        " ",
                        React.createElement("span", { className: "font-bold" }, selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.name),
                        " data"),
                    React.createElement("div", { className: "space-y-2" }, items.map(function (_a) {
                        var image = _a.image, title = _a.title, content = _a.content;
                        return (React.createElement("div", { key: title, className: "flex items-center p-2" },
                            React.createElement("div", { className: "mr-4 flex h-8 w-8 flex-none items-center justify-center" },
                                React.createElement(Image, { src: image, alt: "", className: "w-6 flex-none" })),
                            React.createElement("div", null,
                                React.createElement("h4", { className: "mb-0.5 font-bold leading-none" }, title),
                                React.createElement("p", { className: "leading-none text-black-300" }, content))));
                    }))))),
        React.createElement("footer", { className: "p-4 md:p-6" },
            React.createElement(Button, { onClick: handleSubmit }, "Next"))));
}
